<template>
  <div class="class-1">
    <!-- Header -->
    <AppHeader title="User Management" />

    <!-- Action Buttons -->
    <div class="action-buttons-container">
      <button class="waiters-list-btn" @click="navigateToWaitersList">Waiters List</button>
      <button class="add-user-btn" @click="navigateToAddUser">Add New User</button>
    </div>

    <!-- Table Structure -->
    <table id="userTable">
      <thead>
        <tr>
          <!-- <th>Num.</th> -->
          <th>Login Name</th>
          <!-- <th>Branch</th> -->
          <th>Status</th>
          <th>Operations</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in users" :key="index">
          <!-- <td>{{ user.userId}}</td> -->
          <td>{{ user.loginName }}</td>
          <!-- <td>{{ user.branch }}</td> -->
          <td>{{ user.status }}</td>
          <td class="action-buttons">
            <button data-tooltip="Update Permission" @click="handleUpdatePermission(user)">
              <img :src="require('@/assets/Update_Permissions.png')" alt="Update Permission">
            </button>
            <button data-tooltip="Update" @click="handleUpdate(user)">
              <img src="@/assets/edit_icon.png" alt="Update">
            </button>
            <!-- <button data-tooltip="Set as Default" @click="handleSetAsDefault(user)">
              <img src="https://cdn-icons-png.flaticon.com/512/1828/1828843.png" alt="Set as Default">
            </button> -->
            <button data-tooltip="Delete" @click="confirmDelete(user)">
              <img src="@/assets/delete_icon.png" alt="Delete">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      users: [],
      currentDate: "",
      currentTime: "",
    };
  },
  mounted() {
    this.updateDateTime(); 
    setInterval(this.updateDateTime, 1000); 
    this.fetchUsers(); 
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      this.currentDate = now.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      // Format time as HH:MM AM/PM
      this.currentTime = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
   async fetchUsers() {
  try {
    this.$root.isLoading = true;
    this.loading = true;
    const token = localStorage.getItem('authToken');
    const branchId = localStorage.getItem('branchId');
    
    const response = await fetch(`${this.$BASE_API_URL}/api/users?branchId=${branchId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    this.users = data.data.map(user => ({
      loginName: user.name,
      branch: user.app ? user.app.name : 'N/A',
      userId: user.id,
      status: user.email_verified_at ? 'Active' : 'Inactive',
    }));
  } catch (error) {
    console.error('Error fetching users:', error);
  } finally {
    this.$root.isLoading = false;
    this.loading = false;
  }
},
async confirmDelete(user) {
  if (!this.$hasPermission('delete users')) {
        this.$toast.error('Not Permitted');
        return
    }
  if (confirm(`Are you sure you want to delete ${user.loginName}?`)) {
    try {
      this.$root.isLoading = true;
      const token = localStorage.getItem('authToken');
      
      const response = await fetch(`${this.$BASE_API_URL}/api/users/${user.userId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete user');
      }

      this.$toast.success('User deleted successfully');
      this.fetchUsers(); 
    } catch (error) {
      console.error('Error deleting user:', error);
      this.$toast.error('Failed to delete user');
    } finally {
      this.$root.isLoading = false;
    }
  }
},
    navigateToWaitersList() {
        if (!this.$hasPermission('view waiters')){
        this.$toast.error('Not Permitted');
        return;
    }
      this.$router.push({ name: "WaitersComponent" });
    },
    navigateToAddUser() {
      if (this.$hasPermission('create users')) {
      this.$router.push({ name: "UserComponent" }); 
    } else {
      this.$toast.error('Not Permitted');
    }
    },
    handleUpdatePermission(user) {
       if (this.$hasPermission('assign permissions')) {
      this.$router.push({ name: "PermissionsComponent", params: { id: user.userId} });
    } else {
      this.$toast.error('Not Permitted');
    }
    },
    handleUpdate(user) {
      // this.$router.push({ name: "UpdateUsersComponent", params: { id: user.userId, appId: user.appId} });
       if (this.$hasPermission('edit users')) {
       this.$router.push({ name: "UpdateUsersComponent", params: { id: user.userId, appId: user.appId} });
    } else {
      this.$toast.error('Not Permitted');
    }
    },
    handleSetAsDefault(user) {
      alert(`Set as Default clicked for: ${user.loginName}`);
    },
  },
};
</script>

<style scoped>

.action-buttons-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 0.5rem;
  margin-right: .5rem;
}
.add-user-btn, .waiters-list-btn {
  padding: 10px;
  color: white;
  border: none;
  cursor: pointer;
  width: max-content;
  border-radius: 5px;
}
.add-user-btn {
  background-color: #4caf50;
}
.waiters-list-btn {
  background-color: #2196F3;
}
.action-buttons button {
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 5px;
  position: relative;
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.action-buttons button:hover {
  transform: scale(1.2); /* Slightly enlarge on hover */
  opacity: 0.8; /* Slightly fade on hover */
}
.action-buttons button:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}
.action-buttons button img {
  width: 20px;
  height: 20px;
}
/* Icon Colors */
.action-buttons button[data-tooltip="Update Permission"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(180deg); /* Blue */
}
.action-buttons button[data-tooltip="Update"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(90deg); /* Green */
}
.action-buttons button[data-tooltip="Set as Default"] img {
  filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(45deg); /* Orange */
}
</style>